import { render, staticRenderFns } from "./AdminControlPanel.vue?vue&type=template&id=0395e206&scoped=true&"
import script from "./AdminControlPanel.vue?vue&type=script&lang=js&"
export * from "./AdminControlPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0395e206",
  null
  
)

export default component.exports